import React from 'react';
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">צור קשר</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            נשמח לעזור לך בכל שאלה או בעיה. צוות השירות שלנו כאן בשבילך
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center mb-4">
              <PhoneIcon className="h-6 w-6 text-primary-600 ml-3" />
              <h3 className="text-lg font-semibold text-gray-900">טלפון</h3>
            </div>
            <p className="text-gray-600">03-123-4567</p>
            <p className="text-sm text-gray-500 mt-1">ראשון-חמישי 8:00-18:00</p>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center mb-4">
              <EnvelopeIcon className="h-6 w-6 text-primary-600 ml-3" />
              <h3 className="text-lg font-semibold text-gray-900">אימייל</h3>
            </div>
            <p className="text-gray-600">info@b2bstore.co.il</p>
            <p className="text-sm text-gray-500 mt-1">תגובה תוך 24 שעות</p>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center mb-4">
              <MapPinIcon className="h-6 w-6 text-primary-600 ml-3" />
              <h3 className="text-lg font-semibold text-gray-900">כתובת</h3>
            </div>
            <p className="text-gray-600">רחוב הדוגמה 123<br />תל אביב, ישראל</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
